/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

import { createMonthYearPair } from './utils';

const chance = new Chance();

export default () => {
  const { first: from, second: to } = createMonthYearPair();

  return {
    title: {
      text: chance.pickone([
        'Architect',
        'Archivist',
        'Curator',
        'Museum Technician',
        'Barber',
        'Cosmetologist',
        'Hair Stylist',
        'Biologist',
        'Cashier',
        'Chemist',
        'Chiropractor',
        'Clergy',
        'Commercial Industrial Designer',
        'Counselor',
        'Dentist',
        'Economist',
        'Environmental Scientists and Hydrologist',
        'Fashion Designer',
        'Flight Attendant',
        'Floral Designer',
        'Fundraiser',
        'Ghostwriter',
        'Graphic Designer',
        'Government Manager',
        'Insurance Agent',
        'Interior Designer',
        'Landscape Architect',
        'Librarian',
        'Massage Therapist',
        'Medical Assistant',
        'Medical Transcriptionist',
        'Photographer',
        'Property, Real Estate, and Community Association Manager',
        'Psychologist',
        'Psychology (All Careers)',
        'Real Estate Agent',
        'Social Worker',
        'Writer / Editor',
        'Veterinarian',
        'Zoologist',
      ]),
      ontologyId: chance.url(),
    },
    company: {
      text: chance.pickone([
        'Commonwealth Bank of Australia',
        'Westpac Banking Corp',
        'BHP Billiton Limited',
        'Australia and New Zealand Banking Group',
        'National Australia Bank Ltd.',
        'Rio Tinto Limited',
        'Telstra Corporation Ltd',
        'Wesfarmers Ltd',
        'CSL Limited',
        'Woolworths Limited',
        'Scentre Group Ltd',
        'Macquarie Group Ltd',
        'Transurban Group',
        'Woodside Petroleum Limited',
        'Westfield Corp Ltd',
        'Brambles Limited',
        'AMP Limited',
        'Amcor Limited',
        'Suncorp Group Ltd',
        'QBE Insurance Group Ltd',
        'Sydney Airport Holdings Ltd',
        'Newcrest Mining Limited',
        'Insurance Australia Group Ltd',
        'Vicinity Centres Re Ltd',
        'AGL Energy Ltd',
        'Ramsay Health Care Limited',
        'Goodman Group',
        'Oil Search Limited',
        'Stockland Corporation Ltd',
        'APA Group',
        'Origin Energy Ltd',
        'GPT Group',
        'Asciano Ltd',
        'Caltex Australia Limited',
        'South32 Ltd',
        'Qantas Airways Limited',
        'Aurizon Holdings Ltd',
        'Lend Lease Group',
        'ASX Ltd',
        'James Hardie Industries plc',
        'DEXUS Property Group',
        'Medibank Private Ltd',
        'Sonic Healthcare Limited',
        'Santos Ltd',
        'Mirvac Group',
        'Coca-Cola Amatil Ltd',
        'Orica Ltd',
        'Computershare Limited',
        'Incitec Pivot Ltd',
        'SEEK Limited',
      ]),
      ontologyId: chance.url(),
    },
    from,
    to: chance.d4() === 1 ? null : to,
    achievements: chance.d4() === 1 ? null : chance.paragraph({ sentences: 5 }),
    tracking: {
      events: [{ key: 'served', value: chance.guid() }],
    },
    function: () =>
      chance.pickone([
        {
          id: '2',
          subFunction: {
            id: '3',
          },
        },
        {
          id: '15',
          subFunction: {
            id: '16',
          },
        },
        {
          id: '272',
          subFunction: {
            id: '33',
          },
        },
        {
          id: '15',
          subFunction: {
            id: '126',
          },
        },
        {
          id: '2',
          subFunction: {
            id: '8',
          },
        },
      ]),
    industry: () =>
      chance.pickone([
        {
          id: '1',
        },
        {
          id: '9',
        },
        {
          id: '10',
        },
        {
          id: '11',
        },
        {
          id: '12',
        },
      ]),
  };
};
